import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ImageGalleryIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ImageGallery",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.84 8.13H12.65c-2.3 0-4.16 1.86-4.16 4.16v13.88c0 2.3 1.86 4.16 4.16 4.16h13.19c2.3 0 4.16-1.86 4.16-4.16V12.29c0-2.3-1.86-4.16-4.16-4.16m1.39 18.04c0 .77-.62 1.39-1.39 1.39H12.65c-.77 0-1.39-.62-1.39-1.39V12.29c0-.77.62-1.39 1.39-1.39h13.19c.77 0 1.39.62 1.39 1.39zm-2.5-7.88a1.02 1.02 0 0 0-1.13.27s-4.1 4.77-4.1 4.77c-.06.07-.16.12-.26.12-.06 0-.11-.01-.16-.04s-2.02-2.24-2.02-2.24c-.17-.13-.39-.21-.63-.21-.05 0-.11 0-.16.01-.27.04-.51.19-.66.39s-2.3 2.71-2.3 2.71c-.13.17-.2.38-.2.61 0 .57.46 1.03 1.03 1.03h10.19c.57 0 1.03-.46 1.03-1.03v-5.45c0-.42-.26-.79-.62-.94Zm-7.92-3.68c0 1.02-.83 1.85-1.85 1.85s-1.85-.83-1.85-1.85.83-1.85 1.85-1.85 1.85.83 1.85 1.85m3.7-9.72c0-.26-.21-.46-.46-.46H5.24c-.26 0-.46.21-.46.46v15.73c0 .26.21.46.46.46.77 0 1.39.62 1.39 1.39s-.62 1.39-1.39 1.39A3.24 3.24 0 0 1 2 20.62V4.9a3.24 3.24 0 0 1 3.24-3.24h14.81a3.24 3.24 0 0 1 3.24 3.24c0 .77-.62 1.39-1.39 1.39s-1.39-.62-1.39-1.39Z"
    })
  }));
};